// Recovered from static/main.7bd2eca3bac83dc8.chunk.js, module 5580, offsets 200644:200831. Structure and names inferred from code, not screenshots.

import { module75108 as n } from "../vendor/dependencies.js";
import { module27992 as o } from "../vendor/dependencies.js";
import { module79457 as a } from "../vendor/dependencies.js";
import { module7746 as l } from "../vendor/dependencies.js";
import { interopDefault } from "../vendor/runtime.js";
var r = interopDefault(a),
  s = interopDefault(l);
function c(...e) {
  return (0, o.QP)((0, n.$)(e));
}
r().extend(s());
export { c as cn };
